/**
 * Maps API / paywall codes to user-facing copy for SaaS Free / PAYG errors.
 */

import { SAAS_PAYWALL_COPY } from "../constants/saasPlansCatalog";
import { formatMoney, minPaygUnlockForCurrency } from "./formatBillingMoney";

const EXTRA_COPY = Object.freeze({
  NO_CREDITS: {
    title: "Add credits to continue",
    body: "Your Pay as you go wallet is empty. Buy credits to continue generating.",
  },
  MIGRATION_REQUIRED: {
    title: "Account upgrade required",
    body: "Free-plan usage columns are not migrated yet. Ask an admin to run database migrations.",
  },
  GOOGLE_USER_NOT_FOUND: {
    title: "No TrustVid account yet",
    body: "No account found for this Google user. Create an account with Google from Sign up first.",
  },
  GOOGLE_SSO_NOT_CONFIGURED: {
    title: "Google sign-in unavailable",
    body: "Google sign-in is not configured on this environment.",
  },
});

export function resolveSaasErrorCopy(code, { currency, minUnlock } = {}) {
  if (!code) {
    return null;
  }
  const copy = SAAS_PAYWALL_COPY[code] || EXTRA_COPY[code] || null;
  if (!copy) return null;
  const curr = String(currency || "INR").toUpperCase();
  if (curr !== "USD") return copy;
  const min = minUnlock != null ? minUnlock : minPaygUnlockForCurrency(curr);
  const minLabel = formatMoney(min, curr).replace(/\.00$/, "");
  return {
    title: copy.title,
    body: String(copy.body).replace(/₹1,000/g, minLabel),
  };
}

export function resolveSaasErrorMessage(payload = {}) {
  const code = payload?.paywall?.code || payload?.code || null;
  const copy = resolveSaasErrorCopy(code);
  if (copy?.body) {
    return copy.body;
  }
  if (copy?.title) {
    return copy.title;
  }
  return payload?.message || payload?.error || null;
}

export function extractSaasPaywallCode(errorOrPayload) {
  const payload = errorOrPayload?.response?.data || errorOrPayload || {};
  return payload?.paywall?.code || payload?.code || null;
}

export default resolveSaasErrorCopy;
